/** A player's card (review 0017), apart so each language file stays within its budget. */
export const cardEn = {
  "playerCard.close": "Close",
  "playerCard.loading": "Loading stats…",
  "playerCard.failed": "Stats did not load.",
  "playerCard.retry": "Try again",
  "playerCard.none": "No matches yet",
  "playerCard.rate": "{rate} won",
  "playerCard.favourite": "Plays most: {game}",
  "playerCard.recent": "Last matches",
  "playerCard.recentName": "Last {count} {count|match|matches}",
  "playerCard.result": "{game}, {score} points, {result}",
  "playerCard.won": "won",
  "playerCard.lost": "lost",
  "playerCard.allMatches": "Every match, bots included",
  "playerCard.kick": "Remove from table",
  "playerCard.discord": "Open Discord profile",
} as const;

export const cardAr: Record<keyof typeof cardEn, string> = {
  "playerCard.close": "إغلاق",
  "playerCard.loading": "جارٍ تحميل الإحصائيات…",
  "playerCard.failed": "لم يتم تحميل الإحصائيات.",
  "playerCard.retry": "حاول مرة أخرى",
  "playerCard.none": "لا توجد مباريات بعد",
  "playerCard.rate": "فوز {rate}",
  "playerCard.favourite": "يلعب أكثر: {game}",
  "playerCard.recent": "آخر المباريات",
  "playerCard.recentName": "آخر {count} {count|one:مباراة|two:مباراتين|few:مباريات|other:مباراة}",
  "playerCard.result": "{game}، {score} نقطة، {result}",
  "playerCard.won": "فاز",
  "playerCard.lost": "خسر",
  "playerCard.allMatches": "كل المباريات، بما فيها مع البوتات",
  "playerCard.kick": "أخرجه من الطاولة",
  "playerCard.discord": "افتح ملفه على ديسكورد",
};

export const cardTr: Record<keyof typeof cardEn, string> = {
  "playerCard.close": "Kapat",
  "playerCard.loading": "İstatistikler yükleniyor…",
  "playerCard.failed": "İstatistik yüklenemedi.",
  "playerCard.retry": "Tekrar dene",
  "playerCard.none": "Henüz maç yok",
  "playerCard.rate": "{rate} kazanma",
  "playerCard.favourite": "En çok: {game}",
  "playerCard.recent": "Son maçlar",
  "playerCard.recentName": "Son {count} maç",
  "playerCard.result": "{game}, {score} puan, {result}",
  "playerCard.won": "kazandı",
  "playerCard.lost": "kaybetti",
  "playerCard.allMatches": "Tüm maçlar, botlu dahil",
  "playerCard.kick": "Masadan çıkar",
  "playerCard.discord": "Discord profilini aç",
};
